// AUTO-GENERATED -- do not edit manually.
// Run: yarn workspace @chinese-vendor/i18n codegen:hash to regenerate.
// Source: packages/i18n/bundle_hash.txt (written by BundleExportService).
export const BUNDLED_LOCALIZATION_HASH = '5cc73682d59554be102d74bde0021e8a6310c70c0596a633d7bae684ed0a780c';
